import React, { FC, useEffect, useState } from 'react';
import { Button, ButtonMode } from '../Button';
import styles from './InputAmount.module.css';

export interface InputAmountProps {
    id?: string;
    classes?: string;
    size?: 'sm' | 'md';
    min?: number;
    value: number;
    onChange?: (value: number) => void;
    disabled?: boolean;
    readonly?: boolean;
}

export const InputAmount: FC<InputAmountProps> = ({ id, classes, size, min, value, onChange, disabled, readonly }) => {
    const [count, setCount] = useState<number>(value);

    useEffect(() => {
        value !== count && setCount(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    useEffect(() => {
        value !== count && onChange && onChange(count);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [count]);

    const increment = () => !disabled && !readonly && setCount(count + 1);

    const decrement = () => !disabled && !readonly && count > (min || 0) && setCount(count - 1);

    return (
        <div
            id={id || undefined}
            className={
                styles['input-amount-to-cart'] +
                // size
                ` ${size === 'sm' ? styles['input-amount-to-cart-sm'] : ''}` +
                // extra classes
                ` ${classes || ''}`
            }
            data-testid="input-amount">
            <div className={`input-group ${styles['input-group']}`}>
                <Button
                    label="–"
                    classes="d-flex align-items-center"
                    mode={ButtonMode.secondary}
                    outline={true}
                    onClick={() => decrement()}
                />
                <input
                    type="number"
                    className="form-control text-center"
                    value={count}
                    onChange={(e) => setCount(Number(e.target.value))}
                    step="1"
                    disabled={disabled}
                    readOnly={readonly}
                />
                <Button
                    label="+"
                    classes="d-flex align-items-center"
                    mode={ButtonMode.secondary}
                    outline={true}
                    onClick={() => increment()}
                />
            </div>
        </div>
    );
};
